/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Immature_NeutralInputs */

const en_coach_immature_neutral = /** @type {(inputs: Coach_Immature_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness metrics are still stabilizing (less than 4 weeks of data). Your training load looks balanced so far. Keep logging sessions — reliable coaching insights need about 4 weeks of history.`)
};

const de_coach_immature_neutral = /** @type {(inputs: Coach_Immature_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte pendeln sich noch ein — weniger als 4 Wochen Daten. Dein Umfang sieht ausgeglichen aus. Lade weiter Einheiten hoch — ab 4 Wochen werden die Empfehlungen zuverlässig.`)
};

/**
* | output |
* | --- |
* | "Your fitness metrics are still stabilizing (less than 4 weeks of data). Your training load looks balanced so far. Keep logging sessions — reliable coaching i..." |
*
* @param {Coach_Immature_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_immature_neutral = /** @type {((inputs?: Coach_Immature_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Immature_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_immature_neutral(inputs)
	return de_coach_immature_neutral(inputs)
});